import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Skeleton from "@mui/material/Skeleton";
import Grid from "@mui/material/Grid";
import {
  FormControl,
  InputLabel,
  TextField,
  Button,
  Backdrop,
  CircularProgress,
  Checkbox,
  Link,
  FormHelperText,
  FormControlLabel,
  InputAdornment,
  IconButton,
  Container,
} from "@mui/material";
import VideoSkeleton from "./VideoSkeleton";

const HomeSkeleton = () => {
  return (
    <Box className="userLayout" style={{ marginTop: "0px" }}>
      <Container
        disableGutters={true}
        maxWidth="lg"
        sx={{ background: "#242743", paddingBottom: "116px" }}
      >
        <Box className="home-options-wrapper" style={{ position: "unset" }}>
          <Box className="home-options-inner">
            <Skeleton
              animation="wave"
              variant="circular"
              width={64}
              height={64}
            />

            <Skeleton
              animation="wave"
              variant="circular"
              width={64}
              height={64}
            />
          </Box>
        </Box>
        <Grid
          sx={{
            padding: "20px 0",
            borderBottom: "1px solid #ffffff38",
            borderTop: "1px solid #ffffff38",
          }}
        >
          <Skeleton
            sx={{ height: "250px" }}
            animation="wave"
            variant="rectangular"
          />
        </Grid>
        <Box className="Goal-video-main">
          <Box className="wrapper">
            <Box sx={{ padding: "10px" }}>
              <Skeleton animation="wave" />
            </Box>

            <Box className="goal-wrapper" sx={{ backgroundColor: "#191b2f" }}>
              {Array.from({ length: 10 }).map((ele, index) => (
                // <Box sx={{ padding: "20px 0", backgroundColor: "#242743" }}>
                //   <Box
                //     sx={{
                //       display: "flex",
                //       gap: "20px",
                //       alignItems: "center",
                //       justifyContent: "start",
                //     }}
                //   >
                //     <Skeleton
                //       animation="wave"
                //       variant="circular"
                //       width={48}
                //       height={48}
                //       sx={{ marginLeft: "20px" }}
                //     />
                //     <Box>
                //       <Skeleton
                //         animation="wave"
                //         variant="rectangular"
                //         width={50}
                //         height={10}
                //         sx={{ marginBottom: "10px" }}
                //       />

                //       <Skeleton
                //         animation="wave"
                //         variant="rectangular"
                //         width={100}
                //         height={10}
                //       />
                //     </Box>
                //   </Box>
                //   <Skeleton
                //     variant="rectangular"
                //     sx={{ height: "300px", marginTop: "10px" }}
                //     animation="wave"
                //   />
                //   <Box sx={{ padding: "10px 0 30px 20px" }}>
                //     <Skeleton
                //       variant="rectangular"
                //       width="40%"
                //       height={10}
                //       animation="wave"
                //       sx={{ marginTop: "20px" }}
                //     />
                //     <Skeleton
                //       variant="rectangular"
                //       width="60%"
                //       height={10}
                //       animation="wave"
                //       sx={{ marginTop: "10px" }}
                //     />
                //     <Skeleton
                //       variant="rectangular"
                //       width="20%"
                //       height={10}
                //       animation="wave"
                //       sx={{ marginTop: "10px" }}
                //     />
                //   </Box>
                // </Box>
                <VideoSkeleton key={index} />
              ))}
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default HomeSkeleton;
